import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronUp, ExternalLink } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-white border-t border-slate-100 pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        
        {/* TOP LEVEL: LOGO & NAV */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 mb-12">
          
          {/* BRAND IDENTITY */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <div className="flex items-center gap-4">
              <Link to="/" className="text-xl font-black text-slate-900 tracking-tighter">
                EVAL<span className="text-[#1E3A8A]">NDT</span>
              </Link>
              <div className="h-4 w-[1px] bg-slate-200" />
              <span className="flex items-center gap-1.5 text-[9px] font-black text-slate-400 uppercase tracking-[0.2em]">
                <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" /> 
                System v1.0.2 Stable
              </span>
            </div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
              Industrial Evaluation & Reporting Engine
            </p>
          </div>

          {/* SEMANTIC NAVIGATION */}
          <nav aria-label="Footer Navigation" className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4">
            {[
              { name: 'System Roadmap', path: '/roadmap' },
              { name: 'Privacy Policy', path: '/privacy' },
              { name: 'Data Security', path: '/data' },
              { name: 'Support', path: '/contact' },
            ].map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-[10px] font-black text-slate-500 hover:text-[#F97316] transition-colors uppercase tracking-[0.2em]"
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* UTILITY: BACK TO TOP */}
          <button 
            onClick={scrollToTop}
            className="group flex items-center gap-2 text-[9px] font-black text-slate-400 uppercase tracking-widest hover:text-slate-900 transition-colors"
          >
            Back to Top 
            <div className="p-1.5 rounded-full bg-slate-50 group-hover:bg-slate-100 transition-colors">
              <ChevronUp size={12} />
            </div>
          </button>
        </div>

        {/* BOTTOM LEVEL: LEGAL & CORPORATE HIERARCHY */}
        <div className="pt-8 border-t border-slate-50 flex flex-col md:flex-row items-center justify-between gap-6">
          
          <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.1em]">
              © 2026 Focus NDT Innovations. All Rights Reserved.
            </p>
            <div className="hidden md:block h-3 w-[1px] bg-slate-200" />
            <a 
              href="https://focusndtgroup.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em] flex items-center gap-1.5 hover:text-[#1E3A8A] transition-colors"
            >
              A <span className="text-[#1E3A8A]">Focus NDT Group</span> Enterprise
              <ExternalLink size={10} className="text-slate-300" />
            </a>
          </div>

          {/* SOC COMPLIANCE / SECURITY BADGE MOCKUP */}
          <div className="flex items-center gap-3">
            <div className="text-[8px] font-black px-2 py-1 border border-slate-200 text-slate-400 rounded uppercase tracking-tighter">
              Data Encrypted
            </div>
            <div className="text-[8px] font-black px-2 py-1 border border-slate-200 text-slate-400 rounded uppercase tracking-tighter">
              Industrial Ready
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;